/**
 * 深度合并两个对象，优先使用 source 的值
 * @param target 原始数据
 * @param source 覆盖数据
 * @returns 合并后的数据
 */
function deepMerge<T extends PlainObject, S extends PlainObject>(target: T, source: S): T & S {
  const result: PlainObject = Array.isArray(target) ? [...target] : { ...target }

  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined) {
      if (
        source[key] !== null &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key]) &&
        target[key] !== undefined &&
        typeof target[key] === 'object' &&
        !Array.isArray(target[key])
      ) {
        result[key] = deepMerge(target[key], source[key])
      } else {
        result[key] = source[key]
      }
    }
  }

  return result as T & S
}

type PlainObject = Record<string, any>

export default deepMerge
